import { FC } from 'react';
import DisplayAreaCenteredWrapper from '../../../layout/utilities/displayAreaWrapper';
import BusinessInvolvementPanel from './subComponents/BusinessInvolvementPanel.comonent';
import ExposureBySectorPanel from './subComponents/ExposureBySectorPanel.component';
import ESGOverviewPanel from './subComponents/FundScores.component';
import GeographicalExposurePanel from './subComponents/GeographicalExposurePanel.component';
import ESGPortfolioOverviewPanel from './subComponents/OverviewPanel.component';
import { Grid, Typography } from '@mui/material';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import {
  EsgPages,
  useEsgFundData,
  type EsgPortfolioSummaryPageModel,
} from '../../../../api/rs-hg/esg';
import { IESGPortfolioSummary } from './types/esg-portfolio.types';

const ESGPortfolioSummary: FC<FundInfoComponentProps> = ({
  fundName,
  fundId,
  positionDate,
}) => {
  const portfolioSummaryQuery = useEsgFundData(
    fundId,
    positionDate,
    EsgPages.PORTFOLIO_SUMMARY,
  );

  return (
    <QueryBoundary<EsgPortfolioSummaryPageModel>
      isLoading={portfolioSummaryQuery.isLoading}
      isFetching={portfolioSummaryQuery.isFetching}
      isError={portfolioSummaryQuery.isError}
      error={portfolioSummaryQuery.error}
      data={
        portfolioSummaryQuery.data?.data &&
        Object.keys(portfolioSummaryQuery.data.data).length > 0 &&
        !('no data' in portfolioSummaryQuery.data.data)
          ? portfolioSummaryQuery.data
          : null
      }
      loadingMessages={[
        'Loading ESG Portfolio Data',
        'This may take a few seconds...',
      ]}
      errorMessage="Unable to load ESG portfolio data."
      noDataMessage={`No Data Available for ${positionDate}`}
    >
      {(pageModel) => (
        <Grid container spacing={2} style={{ padding: 8 }}>
          <PortfolioSummary
            esgData={pageModel.data}
            fundId={fundId}
            fundName={fundName}
            positionDate={positionDate}
          />
        </Grid>
      )}
    </QueryBoundary>
  );
};

export default ESGPortfolioSummary;

interface PortfolioSummaryProps {
  esgData: IESGPortfolioSummary;
  fundId: string;
  fundName: string;
  positionDate?: string;
}

const PortfolioSummary: FC<PortfolioSummaryProps> = ({
  esgData,
  fundId,
  fundName,
  positionDate,
}) => {
  const check = esgData && Object.keys(esgData).length > 0;

  return check ? (
    <>
      <ESGPortfolioOverviewPanel
        data={esgData}
        fundId={fundId}
        fundName={fundName}
        positionDate={positionDate}
      />
      <ESGOverviewPanel data={esgData} fundId={fundId} />
      <BusinessInvolvementPanel data={esgData} />
      <ExposureBySectorPanel esgData={esgData} />
      <GeographicalExposurePanel esgData={esgData} />
    </>
  ) : (
    <DisplayAreaCenteredWrapper>
      <Typography variant="h1">{'No Data Available.'}</Typography>{' '}
    </DisplayAreaCenteredWrapper>
  );
};
